import { Utils } from "@/plugins/utils";
import router from '@/router';
import moment from "moment";

export default {
	namespaced: true,
	state: {
		lstCx0: [],
		lastCx0: null,
		cx0: null,
		selectedCx0: null,
		loading: false,
		itemsPerPage: 20,
		search: "",
		hasNext: false,
		since: moment().format("YYYY-MM-DD 00:00"),
		until: moment().format("YYYY-MM-DD 23:59"),
		showCashFlows: false,
		lstCx1: [],
	},
	getters: {
		
	},
	mutations: {
		set(state, cx0){
			state.selectedCx0 = cx0
			state.lstCx1 = cx0.lstCx1
		},
		setLastCx0(state, cx0){
			state.lastCx0 = cx0
		},
		initForm(state){
			state.selectedCx0 = null
			state.lastCx0 = null
			state.showCashFlows = false
			state.lstCx1 = []
		},
		setParamsDataTable(state, payload){
			state.lstCx0 = payload.items
			state.itemsPerPage = payload.limit
			state.hasNext = payload.hasNext
		},
	},
	actions: {
		initForm(store){
			store.commit("initForm")
		},
		async find(store, {cx0caixa, initForm}){
			store.state.loading = true
			if(initForm)
				store.commit("initForm")
			let payload = await this._vm.$axios.get(`/Cashier/Cashier/Find/${cx0caixa}`)
			.then(response => {
				let cx0 = Utils.ValidateAxiosResponse(response.data);
				store.commit("set", cx0)
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		async init(store, cx0){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Abrindo caixa", indeterminate: true }, {root: true})
			await this._vm.$axios.post("/Cashier/Cashier/Init", cx0 )
			.then(response => {
				store.state.cx0 = Utils.ValidateAxiosResponse(response.data);
				router.push("/oryxpdv/caixa")
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
		},
		async close(store){
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Fechando caixa", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.put("/Cashier/Cashier/Close/")
			.then(response => {
				let relatPaths = Utils.ValidateAxiosResponse(response.data);

				let text = "Fechamento de caixa realizado com sucesso."
				let color = "#4CAF50"

				if(relatPaths && relatPaths.length > 0)
					store.dispatch("print/openRelatsPath", relatPaths, { root: true })
				else{
					text += " Não houve vendas ou movimentações para geração de relatório."
					color = "#f8bb86"
				}
			
				store.dispatch("parameters/showSnackBar", {
					show: true,
					timeout: 6000,
					text,
					color,
				}, { root: true })

				router.push("/oryxpdv/caixas")
				store.state.cx0 = null
				return true
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async verifyCashier(store, silent = false){
			let lxd = store.rootState.lxd.lxd

			if(!lxd){
				await store.dispatch("lxd/find", null, { root: true })
				lxd = store.rootState.lxd.lxd
				if (!lxd) {
					store.dispatch("parameters/openDialog", {
							titleText: "Erro",
							titleColor: "red",
							text: "Parâmetros de PDV não cadastrados.",
						}, { root: true })
					return
				}
			}

			if(!lxd || !lxd.lxdcaixa)
				return
				
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "", indeterminate: true }, {root: true})
			let payload = await this._vm.$axios.get("/Cashier/Cashier/VerifyCashier")
			.then(response => {
				store.state.cx0 = Utils.ValidateAxiosResponse(response.data);
				return true
			})
			.catch((error) => {
				if(!silent){
					store.dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message,
						cancelAction: () => router.push("/oryxpdv/abrir-caixa")
					}, { root: true })
				}
				store.state.cx0 = null
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})
			return payload
		},
		async search(store, { limit = 20, page = 1, orderBy = "DESC"}){
			store.state.loading = true
			store.commit("initForm")

			let url = `/Cashier/Cashier/Search?search=${store.state.search}&limit=${limit}&page=${page}&orderBy=${orderBy}`
			if (store.state.since) {
				url+= `&since=${store.state.since}`
			}
			if (store.state.until) {
				url+= `&until=${store.state.until}`
			}

			let payload = await this._vm.$axios.get(url)
			.then(response => {
				let payload = Utils.ValidateAxiosResponse(response.data);
				store.commit("setParamsDataTable", payload)
				return true
			})
			.catch((error) => {
				store.state.lstCx0 = []
				store.state.search = ""
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		},
		async printReportCashStatement(store, { cx0caixaSince = "",cx0caixaUntil = "", summedUp = false, since , until, pd0codigoSince = "" , pd0codigoUntil = "", withoutCashier = false, deduce = false, wallet = false, tipotit = true, cv8nsuSince = "" , cv8nsuUntil = "", snackbarBarOnError = false }){
			if (!since)
				since = moment().format("1899-12-31T00:00")
			if (!until)
				until = moment().format("9999-12-31T23:59")
				
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: true, text: "Imprimindo relatório", indeterminate: true }, {root: true})

			let payload = await this._vm.$axios.post("/Cashier/Cashier/PrintReportCashStatement", {
				cx0caixaSince,
				cx0caixaUntil,
				summedUp,
				since,
				until,
				pd0codigoSince,
				pd0codigoUntil,
				withoutCashier,
				deduce,
				wallet,
				tipotit,
				cv8nsuSince,
				cv8nsuUntil,
			})
			.then(response => {
				let relatPath = Utils.ValidateAxiosResponse(response.data);

				if(relatPath)
					store.dispatch("print/openRelatsPath", [ relatPath ], { root: true })
				
				return true
			})
			.catch((error) => {
				if(snackbarBarOnError){
					store.dispatch("parameters/showSnackBar", {
						show: true,
						timeout: 6000,
						text: error.message,
						color: "red",
					}, { root: true })
				}else{
					store.dispatch("parameters/openDialog", {
						titleText: "Erro",
						titleColor: "red",
						text: error.message
					}, { root: true })
				}
				return false
			});
			store.dispatch("parameters/openGlobalLoading", { showLoadingGlobal: false, text: "" }, {root: true})

			return payload
		},
		async findLastCx0(store){
			store.state.loading = true
			let payload = await this._vm.$axios.get(`/Cashier/Cashier/FindLastCx0`)
			.then(response => {
				let cx0 = Utils.ValidateAxiosResponse(response.data);
				store.commit("setLastCx0", cx0)
				return cx0
			})
			.catch((error) => {
				store.dispatch("parameters/openDialog", {
					titleText: "Erro",
					titleColor: "red",
					text: error.message
				}, { root: true })
				return false
			});
			store.state.loading = false
			return payload
		}
	}
}